
export class ViewItemsModel {
  UserId: number;
  CustAccount: string;
  Currency: string;
  constructor() {
      this.UserId = 0;
      this.CustAccount = '';
      this.Currency = '';
  }
}
